// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.marsblade.test/' : 'https://api.marsblade.com/';
export const contentAPI = process.env.REACT_CONTENT_API;
// export const checkoutAPI = process.env.NODE_ENV === 'development' ? 'https://marsblade.centraqa.com/api/checkout-new' : 'https://marsblade.centra.com/api/checkout-new';
export const checkoutAPI = process.env.REACT_CHECKOUT_API;

export const origin = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://www.marsblade.com';
// export const origin = 'http://www.marsblade.com';

export const paymentMethodsMapping = {
	klarnaCheckout: 'klarna-checkout',
	klarnaOld: 'klarna',
	adyenCheckout: 'adyen-checkout',
	adyenDropIn: 'adyen-drop-in',
	stripeCheckout: 'stripe',
	stripePaymentIntents: 'stripe-payment-intents',
};

export const paymentMethodsOrder = [
	'klarna-checkout',
	'adyen-drop-in',
	'adyen-drop-in-pp',
	'adyen-drop-in-us',
	'adyen-drop-in-us-pp',
	'dibs',
	'paypal',
];

export const addressFieldOrder = [
	'identityNumber',
	'email',
	'firstName',
	'lastName',
	'phoneNumber',
	'address1',
	'address2',
	'zipCode',
	'city',
	'state',
];

export const shippingMethodsMapping = {};

export const urlRoots = [
	'marsblade',
];
